import { AnyAction, combineReducers } from 'redux'

import { appReducer } from './app.reducer'
import rootInitialState from './rootInitialState'

import authReducer from '~/auth/store/auth.reducer'
import balanceReducer from '~/balance/store/balance.reducer'
import barringReducer from '~/barrings/store/barring.reducer'
import bonusReducer from '~/bonus/store/bonus.reducer'
import brandReducer from '~/brand/store/brand.reducer'
// revisar:
import ConsumptionReducer from '~/consumptions/store/consumption.reducer'
import customerReducer from '~/customer/store/customer.reducer'
import discountReducer from '~/discounts/store/discount.reducer'
import energyContractReducer from '~/energyContract/store/energyContract.reducer'
import featureFlagsReducer from '~/featureFlags/store/featureFlags.reducer'
import permissionsReducer from '~/permissions/store/permissions.reducer'
import serviceReducer from '~/services/store/service.reducer'
import subscriptionDetailReducer from '~/subscriptionDetail/store/subscriptionDetail.reducer'

export const initialState = rootInitialState

const rootReducerAll = combineReducers({
  auth: authReducer,
  balance: balanceReducer,
  barrings: barringReducer,
  brand: brandReducer,
  consumptions: ConsumptionReducer,
  customer: customerReducer,
  discounts: discountReducer,
  energyContract: energyContractReducer,
  featureFlags: featureFlagsReducer,
  permissions: permissionsReducer,
  services: serviceReducer,
  bonuses: bonusReducer,
  subscriptionDetail: subscriptionDetailReducer,
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rootReducer = (state: any, action: AnyAction) =>
  [rootReducerAll, appReducer].reduce((stateAcc, reducerFn) => reducerFn(stateAcc, action), state)

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
